import React from "react";

const statusStyles = {
  pending: {
    bg: "bg-amber-50",
    text: "text-amber-700",
    ring: "ring-amber-200",
    label: "Pending",
  },
  received: {
    bg: "bg-sky-50",
    text: "text-sky-700",
    ring: "ring-sky-200",
    label: "Received",
  },
  reviewing: {
    bg: "bg-indigo-50",
    text: "text-indigo-700",
    ring: "ring-indigo-200",
    label: "Reviewing",
  },
  claimed: {
    bg: "bg-emerald-50",
    text: "text-emerald-700",
    ring: "ring-emerald-200",
    label: "Claimed",
  },
};

const ClaimStatusBadge = ({ status = "pending" }) => {
  const s = statusStyles[status] || statusStyles.pending;
  return (
    <span className={`inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-medium ring-1 ${s.bg} ${s.text} ${s.ring}`}>
      <span className={`inline-block h-2 w-2 rounded-full ${s.text.replace("text-", "bg-")}`} />
      {s.label}
    </span>
  );
};

export default ClaimStatusBadge;


